export default __webpack_public_path__ + "static/media/gray-suitcase.5334eae9.svg";